import posthog from "posthog-js";

import { isPostHogAnalyticsEnabled } from "@/lib/analytics/runtime";

let excludedShutdownApplied = false;

/**
 * Hard stop for internal accounts — opt out, stop replay, reset identity.
 * Idempotent; safe if PostHog never initialized.
 */
export function shutdownPostHogForExcludedUser(): void {
  if (excludedShutdownApplied) return;
  excludedShutdownApplied = true;

  if (!isPostHogAnalyticsEnabled() || !posthog.__loaded) return;

  try {
    posthog.opt_out_capturing();
  } catch {
    /* fail-safe */
  }

  try {
    posthog.stopSessionRecording?.();
  } catch {
    /* fail-safe */
  }

  try {
    posthog.reset();
  } catch {
    /* fail-safe */
  }
}

export function isPostHogExcludedSessionShutdown(): boolean {
  return excludedShutdownApplied;
}
